import { StateCreator } from "zustand";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { UpdateTarget } from "../../../domain/useages/target/update-target";
import { RemoteUpdateTarget } from "../../../data/usecases/target/remote-update-target";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { TargetStore } from "../../main/TargetStore";
import { FetchState } from "../../../domain/models/fetch-state";
import Swal from "sweetalert2";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";

export interface UpdateTargetInterface {
  updateTarget: Function;
}

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useUpdateTargetSlice: StateCreator<UpdateTargetInterface> = (
  set,
  get
) => ({
  updateTarget: async (payload: UpdateTarget.Params) => {
  const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
  const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);
    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteUpdateTarget: UpdateTarget = new RemoteUpdateTarget(
      `${BASE_URL}${Endpoints.FETCH_TARGET}`,
      axiosHttpClient
    );
    Swal.fire({
      title: "Updating...",
      text: "Please wait it will take time do not close this window",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    let result = await remoteUpdateTarget.update(payload);
    if (result.success) {
      Swal.fire({
        icon: "success",
        timer: 3000,
        text: result.message,
        customClass: {
          container: "swal2-style",
        },
        confirmButtonColor: "#3085d6",
      });
    } else {
      Swal.fire({
        icon: "error",
        timer: 3000,
        text: result.errors.message,
        customClass: {
          container: "swal2-style",
        },
        confirmButtonColor: "#3085d6",
      });
    }
    TargetStore.getState().fetchTarget(TargetStore.getState().TargetFilter);
  },
});
